export const showToast = (message, type = 'success') => {
  // Remove any existing DOM toast (legacy cleanup)
  const existingToast = document.getElementById('customToast');
  if (existingToast) existingToast.remove();
  
  // Dispatch event for React Toast component
  window.dispatchEvent(new CustomEvent('showToast', {
    detail: { message, type }
  }));
};

window.showToast = showToast;